import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { LocalStorageService } from 'angular-2-local-storage';
import { AngularFirestore } from 'angularfire2/firestore';
import { BehaviorSubject, Observable } from 'rxjs/Rx';

import { Institution } from '../../modules/datamodel/institution';

@Injectable()
export class StateService implements CanActivate {

    public selectedInstitution : BehaviorSubject < Institution | null > = new BehaviorSubject(null);
    private selectedInstitutionPath$ : BehaviorSubject < string | null > = new BehaviorSubject(null);
    constructor(private afs : AngularFirestore, protected storage : LocalStorageService) {
        this
            .selectedInstitutionPath$
            .switchMap(path => {
                return path
                ? this.afs.doc < Institution > (path).valueChanges()
                : new BehaviorSubject < Institution > (null);
            })
            .subscribe(institution => this.selectedInstitution.next(institution))

            let pathFromStorage = this.storage.get < string > ('selectedInstitutionPath')
            if (pathFromStorage) {
                this
                    .selectedInstitutionPath$
                    .next(pathFromStorage);
            }
    }

    public setSelectedInstitutionPath(string) {
        this
            .storage
            .set('selectedInstitutionPath', string);
        this
            .selectedInstitutionPath$
            .next(string);
    }

    canActivate(next : ActivatedRouteSnapshot, state : RouterStateSnapshot) : Observable < boolean > | Promise < boolean > | boolean {
        console.log(!!this.selectedInstitution);
        return !!this.selectedInstitution;
    }
}



// WEBPACK FOOTER //
// ./src/app/services/state/state.service.ts